// extracted by mini-css-extract-plugin
export default {"box":"kV1ebI","badge":"vf62Rc","title":"Zap4X5"};